import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import some from 'lodash/some';
import { bindActionCreators } from 'redux';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import User from 'yoda-site-components/lib/helpers/User/User';
import GoogleAdContainer from 'yoda-checkout-components/lib/components/GoogleAdContainer/GoogleAdContainer';
import DelaySpinner from 'yoda-checkout-components/lib/components/DelaySpinner/DelaySpinner';
import CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import QuickScreenLazy from 'yoda-account-components/lib/components/SYFQuickScreen/QuickScreenLazy';
import { isQuickScreenEligible } from 'yoda-account-components/lib/helpers/Utils/Utils';
import * as messageContentAction from 'yoda-checkout-components/lib/actions/MessageContentAction';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import storeActions from 'yoda-site-components/lib/actions/OrderAction';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import { isAgentLogged } from 'yoda-core-components/lib/helpers/Utils/Utils';
import {
    DP_REWARDS_STATUS,
    GOOGLE_ADS_OC_PAGE_BOTTOM_LEFT,
    GOOGLE_ADS_OC_PAGE_RIGHT_CENTER,
    PAGE_TITLES_ORDER_CONFIRMATION,
    URL_CONFIRMATION_PAGE,
    CURBSIDE_OCP_CONTENT,
    ADJUSTMENT_TYPE_REWARD,
} from 'yoda-checkout-components/lib/common/Constants';
import { logBootstrapPresentInSplunk } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import NarvarScriptLoader from 'yoda-checkout-components/lib/components/ShippingProtection/NarvarScriptLoader';
import {
    scrollToElement,
    updateCartUID,
} from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import LiveChat from 'yoda-checkout-components/lib/components/LiveChat/LiveChat';
import PageBanners from 'yoda-checkout-components/lib/components/PageBanners/PageBanners';
import classnames from 'classnames/bind';
import { CART_PAGE_URL, ACCOUNT_DASHBOARD_URL } from 'yoda-site-components/lib/common/Constants';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

import OCPPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/OCPPreShellLoader/OCPPreShellLoader';
import OrderSummaryPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/OrderSummaryPreShellLoader/OrderSummaryPreShellLoader';
import { setConstructorPurchaseData } from '../../../helpers/Utils/Utils';
import OrderConfirmationMessage from './components/ConfirmationMessage/ConfirmationMessage';
// eslint-disable-next-line import/no-named-as-default
import OrderSummary from '../../../components/OrderSummary/OrderSummary';
import ExpressCheckoutAction from '../../../actions/ExpressCheckoutAction';
// eslint-disable-next-line import/no-named-as-default
import getLatestRewards from '../../../actions/OrderRewardsAction';
// eslint-disable-next-line import/no-named-as-default
import CreateAccountPostOrder from '../../../components/CreateAccountPostOrder/CreateAccountPostOrder';
import * as styles from './OrderConfirmationPage.css';

const cx = classnames.bind(styles);
const section = 'OC';

let isPageLoadSuccessActionFired = false;
let isConstructorPurchaseDataSet = false;
export class OrderConfirmationPage extends Component {
    static defaultProps = {
        actions: {},
        deviceType: {
            isMobile: false,
        },
        orderInfo: {},
        location: {},
        certonaAttributesData: {},
        createAccountPostOrderData: {},
        selectedStore: {},
        orderShippingGroupsInfo: [],
        isSessionTimedOut: false,
        context: {},
        enableClickStreamLogs: false,
        enableFreestarAdComponent: true,
        enableOCPCertonaZone: true,
        signInSliderDetails: {},
        isNative: false,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func),
        orderDetails: PropTypes.objectOf(PropTypes.object).isRequired,
        orderInfo: PropTypes.objectOf(PropTypes.object),
        selectedStore: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        orderShippingGroupsInfo: PropTypes.arrayOf(
            PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        ),
        createAccountPostOrderData: PropTypes.objectOf(PropTypes.object),
        certonaAttributesData: PropTypes.objectOf(PropTypes.any),
        deviceType: PropTypes.objectOf(PropTypes.bool),
        isSessionTimedOut: PropTypes.bool,
        context: PropTypes.objectOf(PropTypes.object),
        location: PropTypes.objectOf(PropTypes.object),
        showGlobalLoader: PropTypes.bool.isRequired,
        enableClickStreamLogs: PropTypes.bool,
        enableFreestarAdComponent: PropTypes.bool,
        enableOCPCertonaZone: PropTypes.bool,
        signInSliderDetails: PropTypes.objectOf(PropTypes.object),
        isNative: PropTypes.bool,
    };

    constructor() {
        super();
        this.state = {
            isLoggedInUser: User.isUserLoggedIn(),
            createAccountFromHeader: false,
            orderIdLocalStorage: LocalStorage.getData('orderIdNumber', ''),
            orderUserNameLocalStorage: LocalStorage.getData('orderUserName', ''),
            orderUserEmailLocalStorage: LocalStorage.getData('orderUserEmail', ''),
            isQSBannerEligible: false,
        };
        this.enableExpressCheckoutAction = this.enableExpressCheckoutAction.bind(this);
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!__SERVER__) {
            window.jcpDLjcp = {}; // Added this object initialization to allow ensighten team to fix the issue.
            scrollToElement();
            // To Add or Update UID Cookie
            updateCartUID(this.props.orderDetails);
        }
    }

    /**
     * This is temp fix only for desktop, we need to hide the change store link as it is not working due to compatibility issues.
     * Please dont remove this code.
     */
    componentDidMount() {
        const {
            // eslint-disable-next-line no-shadow
            actions: { getLatestRewards },
            context: { featureFlags: { splunkLogs = {} } } = {},
        } = this.props;
        const { isLoggedInUser } = this.state;
        const storeLocator = document.getElementsByClassName('globalHeader_storeLocator');
        if (!isEmpty(storeLocator) && storeLocator[0]) {
            storeLocator[0].style = 'display:none';
        }
        // if orderDetails is available on pageMount, fire analytics immediately
        const {
            orderDetails,
            selectedStore,
            orderShippingGroupsInfo,
            orderInfo,
            enableClickStreamLogs,
            isNative,
            context,
        } = this.props;
        const enableConstructorIO = context?.featureFlags?.enableConstructorIO ?? true;
        /* istanbul ignore next */
        if (
            ((orderDetails && orderDetails.data) || !isEmpty(this.state.orderIdLocalStorage)) &&
            !isPageLoadSuccessActionFired
        ) {
            if (orderDetails?.data?.bag) {
                if (enableConstructorIO) {
                    this.setConstructorPurchaseDataAfterPageLoad(orderDetails.data);
                }
                isPageLoadSuccessActionFired = true;
                setTimeout(() => {
                    this.enableExpressCheckoutAction();
                }, 200);
            }

            window.addEventListener('load', () => {
                const adjustments = get(orderDetails, 'data.adjustments', []);
                const isRewardsApplied = some(
                    adjustments,
                    (el) => el.code === ADJUSTMENT_TYPE_REWARD
                );
                if (isLoggedInUser && isRewardsApplied) {
                    getLatestRewards();
                }
            });
        }
        if (isEmpty(selectedStore) || isEmpty(selectedStore.storeDetails)) {
            let storeIdPayload = null;
            if (
                orderShippingGroupsInfo &&
                orderShippingGroupsInfo[0] &&
                orderShippingGroupsInfo[0].store
            ) {
                storeIdPayload = { storeId: orderShippingGroupsInfo[0].store.id };
            }
            this.props.actions.getStoreByStoreId(storeIdPayload);
        }
        // MCYODA-5344: returning the user to cart on browserback
        // eslint-disable-next-line no-restricted-globals
        history.pushState(null, null, location.href);
        /* istanbul ignore next */
        if (!isAgentLogged(this.props.context)) {
            // agent should not land to cart page when he clicked on Back to Pending order
            window.onpopstate = (e) => {
                e.preventDefault();
                window.location.href = '/cart';
            };
        }

        if (splunkLogs && splunkLogs.enableBootstrapLogOC) {
            /* istanbul ignore next */
            window.addEventListener('beforeunload', () => {
                try {
                    /* istanbul ignore next */
                    logBootstrapPresentInSplunk(window.digitalData, enableClickStreamLogs);
                } catch (error) /* istanbul ignore next */ {
                    console.log(error);
                }
            });
        }

        TokenProvider.set('checkoutPrevUrl', URL_CONFIRMATION_PAGE);
        if (orderInfo.showCurbsideBanner) {
            this.props.actions.getMessageContent(CURBSIDE_OCP_CONTENT);
        }

        this.setState({
            isQSBannerEligible: isQuickScreenEligible({
                isNative,
                featureFlags: context.featureFlags,
                preferences: context?.preferences || {},
            }),
        });
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { signInSliderDetails = {} } = nextProps;
        const { signInSliderDetails: prevSignInSliderDetails = {} } = this.props;
        if (signInSliderDetails.accountCreatedFromOCP) {
            this.setState({
                createAccountFromHeader: signInSliderDetails.accountCreatedFromOCP,
            });
        }
        if (
            !prevSignInSliderDetails.authenticationSuccess &&
            signInSliderDetails.authenticationSuccess
        ) {
            window.location.href = ACCOUNT_DASHBOARD_URL;
        }
    }

    componentDidUpdate() {
        const { orderDetails, context } = this.props;
        const enableConstructorIO = context?.featureFlags?.enableConstructorIO ?? true;
        // if orderDetails is available, fire analytics immediately
        /* istanbul ignore next */
        if (
            ((orderDetails && orderDetails.data) || !isEmpty(this.state.orderIdLocalStorage)) &&
            !isPageLoadSuccessActionFired
        ) {
            if (orderDetails?.data?.bag) {
                isPageLoadSuccessActionFired = true;
                setTimeout(() => {
                    this.enableExpressCheckoutAction();
                }, 200);
            }
        }
        if (enableConstructorIO && orderDetails?.data?.bag) {
            this.setConstructorPurchaseDataAfterPageLoad(orderDetails.data);
        }
        // Reset the price in the header as the order has been placed now and bag will be empty
        /* istanbul ignore next */
        const bagPrice = document.getElementsByClassName('shopppingBag_price__value');
        /* istanbul ignore if */
        if (!isEmpty(bagPrice) && bagPrice[0]) {
            bagPrice[0].innerText = '0.00';
        }
    }

    enableExpressCheckoutAction = () => {
        const { actions } = this.props;
        const enableExpressCheckout = LocalStorage.getData('enableExpressCheckout');
        /* istanbul ignore if */
        if (enableExpressCheckout) {
            actions.expressCheckoutDisplayed(true);
            enableExpressCheckout.paymentExpressCheckout && actions.updateExpressCheckoutPayment();
            enableExpressCheckout.addressExpressCheckout && actions.updateExpressCheckoutAddress();
            LocalStorage.removeData('enableExpressCheckout');
        }
    };

    setConstructorPurchaseDataAfterPageLoad = (orderData) => {
        const constructorIOIndexKey = this.props?.context?.preferences?.constructorIOIndexKey || '';

        if (__SERVER__ || isConstructorPurchaseDataSet || !orderData?.bag) {
            return;
        }
        setConstructorPurchaseData(orderData, constructorIOIndexKey);
        isConstructorPurchaseDataSet = true;
    };

    renderBottomBanner = () => {
        const { context, orderInfo } = this.props;
        const { enableMobileBvOcp = true } = context?.featureFlags || {};
        const customClass = context.featureFlags.enableMobileBvOcp ? 'stackAdContainer' : '';
        return (
            <PageBanners
                googleBVAdsId={GOOGLE_ADS_OC_PAGE_BOTTOM_LEFT}
                customClass={`${cx(customClass)} ${dt(['lg:!pb-4', 'smMd:!pb-0'])}`}
                isOcpPage={enableMobileBvOcp}
                isJcpCardInOrder={(orderInfo && orderInfo.isJcpCardInOrder) || false}
            />
        );
    };

    render() {
        const {
            deviceType,
            isSessionTimedOut,
            showGlobalLoader,
            location,
            enableFreestarAdComponent,
            enableOCPCertonaZone,
            orderInfo,
            orderDetails,
            disableNarvarShippingProtection,
            narvarShippingProtectionJs,
        } = this.props;
        const rewardsStatus = TokenProvider.get(DP_REWARDS_STATUS);
        const query = location ? makeQuery(location.search) : undefined;
        // agent should not land to cart page when he clicked on Back to Pending order
        const { signInSliderDetails = {} } = this.props;
        if (
            !signInSliderDetails.authenticationSuccess &&
            !isAgentLogged(this.props.context) &&
            (isSessionTimedOut || (!__SERVER__ && isEmpty(query)))
        ) {
            window.location.href = CART_PAGE_URL;
        }
        const createAccPostOrderData =
            this.props.createAccountPostOrderData && this.props.createAccountPostOrderData.data
                ? this.props.createAccountPostOrderData.data
                : {};
        const { accountRequestStatus = '' } = createAccPostOrderData;
        const { isQSBannerEligible } = this.state;

        const ShippingProtectionAdded = orderInfo?.shippingProtectionSelected || false;
        const shippingProtectionAmount = orderInfo?.shippingProtectionAmount || 0;
        return (
            <Layout>
                <Helmet title={PAGE_TITLES_ORDER_CONFIRMATION} />
                {showGlobalLoader && <DelaySpinner />}

                <section
                    className={`${cx(
                        'orderConfirmationBlock',
                        'tailwindGrid',
                        !deviceType.isDesktop && 'pointerCursor'
                    )} ${dt(['h-full', !deviceType.isDesktop && 'cursor-pointer', 'text-black'])}`}
                    data-automation-id="at-ocp-main-block"
                >
                    <article className={dt(['sm:m-6'])}>
                        <div className={dt(['lg:flex', 'justify-between'])}>
                            {orderInfo && orderInfo.showInlineLoader ? (
                                <div
                                    className={`${cx(
                                        'sm12',
                                        'md12',
                                        'lg7',
                                        'xl7',
                                        'rowInnerWrapper'
                                    )} ${dt(['smMd:!p-0', 'lg:!px-0'])}`}
                                >
                                    <OCPPreShellLoader />
                                </div>
                            ) : (
                                <section
                                    className={`${cx(
                                        'sm12',
                                        'md12',
                                        'lg7',
                                        'xl7',
                                        'rowInnerWrapper'
                                    )} ${dt(['smMd:!p-0', 'lg:!px-0'])}`}
                                    data-automation-id="at-ocp-inner-wrapper"
                                >
                                    <section
                                        className={`${cx(
                                            'rowBlock',
                                            'orderConfirmationMsgWrapper'
                                        )} ${dt(['sm:!p-0', 'sm:!m-0'])}`}
                                        data-automation-id="at-ocp-inner-confirm-msg-wrapper"
                                    >
                                        {isQSBannerEligible ? (
                                            <div className={dt(['my-6'])}>
                                                <QuickScreenLazy bannerType="Row" />
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        {!isEmpty(query) && !orderDetails.orderNotFound && (
                                            <div>
                                                <OrderConfirmationMessage
                                                    orderId={get(query, 'OrderId')}
                                                    sccOrder={get(query, 'scc')}
                                                    potd={get(query, 'potd')}
                                                    orderIdLocalStorage={
                                                        this.state.orderIdLocalStorage
                                                    }
                                                    orderUserNameLocalStorage={
                                                        this.state.orderUserNameLocalStorage
                                                    }
                                                    orderUserEmailLocalStorage={
                                                        this.state.orderUserEmailLocalStorage
                                                    }
                                                />
                                            </div>
                                        )}
                                    </section>
                                    {this.state.isLoggedInUser &&
                                    (rewardsStatus === 'NotEnrolled' ||
                                        accountRequestStatus === 'SUCCESS') ? (
                                        // Rendering Enroll Rewards Section only for logged in user when rewards status in Not Enrolled
                                        <section
                                            className={`${cx('rowBlock')} ${dt(['!p-0', '!m-0'])}`}
                                        >
                                            <div className={`${cx('row')} ${dt(['!p-0', '!m-0'])}`}>
                                                <CreateAccountPostOrder renderRewards />
                                            </div>
                                        </section>
                                    ) : (
                                        (this.state.createAccountFromHeader ||
                                            (!this.state.isLoggedInUser &&
                                                !this.props.createAccountPostOrderData
                                                    .isAccountExists)) && (
                                            // Rendering CreateAccount Section when user is not logged in and account exixts in dp
                                            <section
                                                className={`${cx('rowBlock')} ${dt([
                                                    'sm:!p-0',
                                                    'sm:!m-0',
                                                ])}`}
                                            >
                                                <div
                                                    className={`${cx('row')} ${dt([
                                                        'sm:!p-0',
                                                        'sm:!m-0',
                                                    ])}`}
                                                >
                                                    <CreateAccountPostOrder
                                                        createAccountFromHeader={
                                                            this.state.createAccountFromHeader
                                                        }
                                                    />
                                                </div>
                                            </section>
                                        )
                                    )}
                                    {!isEmpty(this.props.certonaAttributesData) &&
                                        enableOCPCertonaZone && (
                                            <section
                                                className={`${cx('rowBlock')} ${dt([
                                                    'sm:!p-0',
                                                    'sm:!m-0',
                                                ])}`}
                                            >
                                                <div
                                                    className={`${cx('certonaContainer')} ${dt([
                                                        'sm:!p-0',
                                                        'sm:!my-10',
                                                        'clear-both',
                                                        'overflow-hidden',
                                                    ])}`}
                                                    data-automation-id="at-ocp-prod-cartridge-wrapper"
                                                >
                                                    <CertonaZone
                                                        page="PURCHASE"
                                                        slotDetails={{
                                                            pageType: 'PURCHASE',
                                                            attributes: {
                                                                schemes: 'orderconfirm1_rr',
                                                                recommendations: true,
                                                                ...this.props.certonaAttributesData,
                                                            },
                                                            loader: 'certona',
                                                            slotId: 'orderconfirm1_rr',
                                                        }}
                                                        schemasToRender={['orderconfirm1_rr']}
                                                        disableLazyLoad
                                                    />
                                                </div>
                                            </section>
                                        )}
                                </section>
                            )}
                            <section
                                className={`${cx('sm12', 'md12', 'lg4', 'xl4')} ${dt([
                                    orderInfo && orderInfo.number ? 'lg:h-[400px]' : 'lg:h-[200px]',
                                    '!p-0',
                                    'm-0',
                                ])}`}
                            >
                                {orderInfo && orderInfo.showInlineLoader ? (
                                    <OrderSummaryPreShellLoader hideSubmitBtn />
                                ) : (
                                    <div
                                        className={`${cx(
                                            'rowBlock',
                                            'orderSummary',
                                            'orderSummaryUI'
                                        )} ${dt(['!m-0', '!p-0'])}`}
                                        data-automation-id="at-ocp-page-ordersummary"
                                    >
                                        <div
                                            className={`${cx('orderSummaryInnerWrapper')} ${dt([
                                                'p-4',
                                            ])}`}
                                        >
                                            <OrderSummary hideVoucherNumberFromConformation />
                                        </div>
                                    </div>
                                )}
                                <div
                                    className={`${cx('rowBlock', 'googleAds')} ${dt([
                                        'm-4',
                                        '!mt-10',
                                        orderInfo && orderInfo.showInlineLoader && 'smMd:!mb-0',
                                        orderInfo && orderInfo.showInlineLoader && 'smMd:!mt-0',
                                        'text-center',
                                    ])}`}
                                    id="div-gpt-ocp-right-center"
                                    data-automation-id="div-gpt-ocp-right-center"
                                >
                                    <GoogleAdContainer
                                        displayId={GOOGLE_ADS_OC_PAGE_RIGHT_CENTER}
                                        enableFreestarAdComponent={enableFreestarAdComponent}
                                    />
                                </div>
                            </section>
                        </div>
                        {this.renderBottomBanner()}
                    </article>
                    {!__SERVER__ && (
                        <NarvarScriptLoader
                            page="checkout_ocp"
                            narvarShippingProtectionJs={narvarShippingProtectionJs}
                            shippingProtectionSelected={ShippingProtectionAdded}
                            disableNarvarShippingProtection={disableNarvarShippingProtection}
                            shippingProtectionAmount={shippingProtectionAmount}
                            orderNumber={orderInfo?.number}
                            title=""
                        />
                    )}
                    <LiveChat />
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        context,
        certonaAttributesData,
        orderDetails,
        orderInfo,
        selectedStore,
        orderShippingGroupsInfo,
        createAccountPostOrderData,
        session,
        showGlobalLoader,
        signInSliderDetails,
    } = state;
    const deviceType = get(state, 'context.deviceType');
    const enableClickStreamLogs = get(state, 'context.featureFlags.enableClickStreamLogs', false);
    const disableNarvarShippingProtection = get(
        state,
        'context.featureFlags.disableNarvarShippingProtection',
        false
    );
    const narvarShippingProtectionJs = get(
        state,
        'context.preferences.narvarShippingProtectionJs',
        ''
    );
    const { enableFreestarAdComponent = true, enableOCPCertonaZone = true } =
        context?.featureFlags || {};
    return {
        context,
        certonaAttributesData,
        orderDetails,
        orderInfo,
        selectedStore,
        orderShippingGroupsInfo,
        createAccountPostOrderData,
        deviceType,
        isSessionTimedOut: session.isSessionTimedOut,
        showGlobalLoader,
        enableClickStreamLogs,
        enableFreestarAdComponent,
        signInSliderDetails,
        enableOCPCertonaZone,
        disableNarvarShippingProtection,
        narvarShippingProtectionJs,
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        Object.assign(
            CheckoutAnalyticsAction,
            storeActions,
            ExpressCheckoutAction,
            messageContentAction,
            getLatestRewards
        ),
        dispatch
    ),
});

export default withBoundaryError(
    connect(mapStateToProps, mapDispatchToProps)(OrderConfirmationPage),
    section
);
